import { getDate } from '../../../../utils/dateUtils';

const PaymentMadeDetailTable = ({
	tableColumns = [],
	tableRows = [],
	type,
	setPbId,
	setIsPBDrawerOpen,
}) => {
	return (
		<table
			style={{
				width: '100%',
				border: '1px solid #dee2e6',
				borderCollapse: 'collapse',
				textAlign: 'left',
			}}
		>
			<thead>
				<tr style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}>
					{tableColumns.map((col, index) => (
						<th
							key={index}
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: col === 'Bill Number' || col === 'Bill Date' ? 'left' : 'right',
							}}
						>
							{col}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{tableRows.map((pb) => (
					<tr>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'left',
								color: '#3B58FF',
								cursor: 'pointer',
							}}
							onClick={() => {
								setPbId(pb?.purchase_bill_id);
								setIsPBDrawerOpen(true);
							}}
						>
							{pb?.purchase_bill?.bill_number}
						</td>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'left',
								color: '#555B67',
							}}
						>
							{getDate(pb?.purchase_bill?.bill_date)}
						</td>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'right',
								color: '#555B67',
							}}
						>
							{Number(pb?.purchase_bill?.bill_amount).toFixed(2)}
						</td>
						<td
							style={{
								padding: '8px',
								border: '1px solid #dee2e6',
								textAlign: 'right',
								color: '#555B67',
							}}
						>
							{type === 'pm'
								? Number(pb?.payment_amount).toFixed(2)
								: Number(pb?.excess_paid_amount).toFixed(2)}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
};
export default PaymentMadeDetailTable;
